export default __webpack_public_path__ + "static/media/403Illustration_3.74825c0b.svg";